// LIBRARIES //
import React, { useState } from 'react';
import styled from 'styled-components';
import MediaQuery from 'react-responsive';
import { MdKeyboardArrowDown as DownArrowIcon } from 'react-icons/md';

// COMPONENTS //
import Card from './Card';

// HELPERS //
import { colors } from 'helpers/ColorHelper';
import { sizes } from 'helpers/MediaHelper';
import { getTranslatedString } from 'helpers/i18n';

const StyledExpandButton = styled.div`
  text-align: center;
  margin-top: ${(props) => (props.expanded ? '24px' : '10px')};
  cursor: pointer;
  color: ${colors.DEEP_BLUE};
`;

const StyledDownArrowIcon = styled(DownArrowIcon)`
  transition-duration: 0.18s;
  transform: ${(props) => (props.arrowPointsUp ? 'rotate(180deg)' : 'rotate(0)')};
`;

const ExpandableActivityCard = ({
  id,
  icon,
  handleClick,
  title,
  propertyName,
  dateString,
  bodyContent,
  hiddenContent,
  RightIcon,
  rightSubHeader,
}) => {
  const [expanded, setExpanded] = useState(false);

  const toggleExpanded = () => {
    return setExpanded(!expanded);
  };

  return (
    <Card
      id={id}
      handleClick={handleClick}
      icon={icon}
      title={title}
      propertyName={propertyName}
      dateString={dateString}
      rightSubHeader={rightSubHeader}
      RightIcon={RightIcon}
    >
      <MediaQuery query={`(min-device-width: ${sizes.desktop}px)`}>
        {bodyContent}
        {hiddenContent && (
          <div>
            {expanded ? hiddenContent : null}
            <StyledExpandButton onClick={toggleExpanded}>
              {expanded
                ? getTranslatedString('landlordPortal.tenantDetails.activity.showLess')
                : getTranslatedString('landlordPortal.tenantDetails.activity.showMore')}
              <StyledDownArrowIcon size={20} arrowPointsUp={expanded} />
            </StyledExpandButton>
          </div>
        )}
      </MediaQuery>
      <MediaQuery query={`(max-device-width: ${sizes.mobile}px)`}>
        {(hiddenContent || bodyContent) && (
          <div>
            {expanded ? bodyContent : null}
            {expanded ? hiddenContent : null}
            <StyledExpandButton onClick={toggleExpanded} expanded={expanded}>
              {expanded
                ? getTranslatedString('landlordPortal.tenantDetails.activity.showLess')
                : getTranslatedString('landlordPortal.tenantDetails.activity.showMore')}
              <StyledDownArrowIcon size={20} arrowPointsUp={expanded} />
            </StyledExpandButton>
          </div>
        )}
      </MediaQuery>
    </Card>
  );
};

export default ExpandableActivityCard;
